import {
  clearAuthFromLocalStorage,
  getAuthFromLocalStorage,
} from "@/utils/common.util";
import axios from "axios";

const axiosInstanceForBlob = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  timeout: 10000,
});

// Request Interceptor
axiosInstanceForBlob.interceptors.request.use(
  (config) => {
    const { auth, token } = getAuthFromLocalStorage();
    if (!auth) {
      window.location.href = "/login";
    }
    config.headers["Authorization"] = `Token ${token}`;
    config.responseType = "blob";
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response Interceptor
axiosInstanceForBlob.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.status === 401) {
      clearAuthFromLocalStorage();
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default axiosInstanceForBlob;
